import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import Toolbar from "@mui/material/Toolbar";

import MaterialBox from "../../../../components/MaterialBox";
import { setMiniSidenav, setTransparentNavbar, useMaterialUIController } from "../../../../context";
import { navbarContainer, navbarRow } from "./styles";
import Breadcrumbs from "./components/Breadcrumbs";
import NotificationItem from "./components/NotificationItem";
import MaterialAvatar from "../../../../components/MaterialAvatar";
import { Avatar, Box, Stack, Tooltip } from "@mui/material";
import stringAvatar from "../../../../functions/stringAvatar";
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import LogoutIcon from '@mui/icons-material/Logout';
import MaterialTypography from "../../../../components/MaterialTypography";
import axios from "axios";
import { useSnackbar } from "../../../../context/popup";
import userImage from "../../../../assest/images/user.png"
import { Apps, Help, Home } from "@mui/icons-material";
import Waffle from "./components/Waffle";

function DashboardNavbar({ absolute, light, isMini }) {

  const userDetails = JSON.parse(sessionStorage.getItem("user"));
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar, openConfigurator } = controller;
  const [openMenu, setOpenMenu] = useState(false);
  const route = useLocation().pathname.split("/").slice(1);
  const [user, setUser] = useState({
    name: userDetails?.first_name + ' ' + userDetails?.last_name || "Unknown User",
    picture: "",
    email: ""
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [pageState, setPageState] = useState({
    state: 'init'
  });
  const [openWaffle, setOpenWaffle] = useState(false);

  useEffect(() => {
    const getUser = () => {
      setUser({
        name: user.name,
        email: user.email,
        picture: user.picture
      })
      setPageState({
        state: 'default'
      })
    }
    getUser()
  }, [])

  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    }

    /** 
     The event listener that's calling the handleTransparentNavbar function when 
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleCloseMenu = () => setOpenMenu(false);
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const open = Boolean(openMenu)
  // Render the notifications menu
  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}

    >
      <NotificationItem icon={
        <>
          {
            user.picture ?
              <Avatar alt={user.name} src={user.picture} sx={{ width: 24, height: 24 }} />
              :
              <MaterialAvatar
                size="sm"
                {
                ...stringAvatar(user.name || user.email || "UNNAMED")
                }
              />
          }
        </>
      } title={user.name || user.email} />
      <NotificationItem id="logout" onClick={signOut} icon={<LogoutIcon />} title={"Logout"} />
    </Menu>
  );

      const signOut = async (navigate) => {

      try {
        // Get token
        const token = sessionStorage.getItem('token')
  
        if (!token) {
          showSnackbar('No token found for logout',"error");
        }
    
        //  Call Logout API
        const response = await axios.post(process.env.REACT_APP_LOGOUT_API_BASE_URL,
          {},
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`
            }
          }
        )  
        const data = response.data    
        if (data?.success === false) {
          showSnackbar(data.message || 'Logout API call failed',"error")
          return
        }    
        showSnackbar(data.message || 'Logged out successfully',"success");    
        //  Delay for UX

        setTimeout(async () => {
          //  Clear storage
          sessionStorage.clear()
          localStorage.clear()    
          //  Clear cookies
          document.cookie.split(';').forEach(cookie => {
            document.cookie = cookie
              .replace(/^ +/, '')
              .replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`)
          })    
          //  Clear cache (PWA / SW)
          if ('caches' in window) {
            const cacheNames = await caches.keys()
            await Promise.all(cacheNames.map(name => caches.delete(name)))
          }    
          //  HARD redirect (kills memory + cache)
          window.location.replace(process.env.REACT_APP_APP_URL ||
            '/'
          )

        }, 500)

      } catch (error) {
        console.error('Logout failed:', error)
        showSnackbar(error.message || 'Something went wrong during logout',"error");
      }

    }

  const handleOpenWaffle = (event) => {
    setOpenWaffle(true)
    setAnchorEl(event.currentTarget); // this is anchorEl
  };

  const handleCloseWaffle = () => {
    setOpenWaffle(false);
    setAnchorEl(null);
  }

  const hanldeHomeClick = async () => {
    const token = sessionStorage.getItem('token')
    if(!token){
      window.location.replace(process.env.REACT_APP_APP_URL+"app-details")
    }
    else{
      try {
          // Get token
    
          if (!token) {
            showSnackbar('No token found for Navigate',"error");
          }
      
          //  Call Logout API
          const response = await axios.post(process.env.REACT_APP_LOGOUT_API_BASE_URL,
            {},
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
              }
            }
          )  
          const data = response.data    
          if (data?.success === false) {
            showSnackbar(data.message || 'API call failed',"error")
            return
          }    
          showSnackbar('Going Back to Home',"success");    
          //  Delay for UX
  
          setTimeout(async () => {
            //  Clear storage
            sessionStorage.clear()
            localStorage.clear()    
            //  Clear cookies
            document.cookie.split(';').forEach(cookie => {
              document.cookie = cookie
                .replace(/^ +/, '')
                .replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`)
            })    
            //  Clear cache (PWA / SW)
            if ('caches' in window) {
              const cacheNames = await caches.keys()
              await Promise.all(cacheNames.map(name => caches.delete(name)))
            }    
            //  HARD redirect (kills memory + cache)
            window.location.replace(process.env.REACT_APP_APP_URL+"/app-details" ||
              '/'
            )
  
          }, 500)
  
        } catch (error) {
          console.error('Logout failed:', error)
          showSnackbar(error.message || 'Something went wrong during logout',"error");
        }
    }
  }

  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      color="inherit"
      sx={{
        borderRadius: 0,
        backdropFilter: "blur(10px)",              // glass blur effect
        WebkitBackdropFilter: "blur(10px)",        // Safari support
      }}
    >
      <Waffle open={openWaffle} anchorEl={anchorEl} handleClose ={handleCloseWaffle}/>
      <Toolbar minHeight='10px !important' sx={(theme) => navbarContainer(theme)}>
        {
          pageState.state === 'default' && (
            <>
              <MaterialBox color="inherit" mb={{ xs: 1, md: 0 }} sx={(theme) => navbarRow(theme, { isMini })}  >
                <MaterialBox display="flex">
                  <Icon fontSize="medium" onClick={handleMiniSidenav} sx={{ cursor: "pointer", color: "white" }}>
                    {miniSidenav ? <MenuOpenIcon /> : <MenuIcon />}
                  </Icon>
                  <MaterialBox ml={1}>
                    <Breadcrumbs icon={<HomeIcon />} title={route[route.length - 1]} route={route} light={light} />
                  </MaterialBox>
                </MaterialBox>
              </MaterialBox>

              <MaterialBox sx={{
                display: 'flex',
                flexDirection: 'row',
                gap: 0.5
              }}>
                <Tooltip title="Support" disableInteractive>
                  <Box
                  onClick={() => window.open("https://tickets.soucient.com/", "_blank")}
                  sx={{
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "dark.main",
                      color: "white",
                      padding: "12px",
                      borderRadius: "50px 50px",
                      cursor: "pointer"
                    }}>
                    <Help sx={{color: "#fff"}}/>
                  </Box>
                </Tooltip>
                <Tooltip title="Home" disableInteractive>
                  <Box
                  onClick={hanldeHomeClick}
                  sx={{
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "dark.main",
                      color: "white",
                      padding: "12px",
                      borderRadius: "50px 50px",
                      cursor: "pointer"
                    }}>
                    <Home sx={{color: "#fff"}}/>
                  </Box>
                </Tooltip>
                <Tooltip title="Apps" disableInteractive onClick={handleOpenWaffle}>
                  <Box
                  sx={{
                      display: "flex",
                      alignItems: "center",
                      backgroundColor: "dark.main",
                      color: "white",
                      padding: "12px",
                      borderRadius: "50px 50px",
                      cursor: "pointer"
                    }}>
                    <Apps sx={{color: "#fff"}}/>
                  </Box>
                </Tooltip>
                <Tooltip title="User Details" disableInteractive>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      height: 45,
                      backgroundColor: "#071235",
                      color: "white",
                      borderRadius: "40px 40px 0px 40px",
                      width: "fit-content",
                      cursor: "pointer"
                    }}
                    onClick={handleOpenMenu}
                  >                  
                    <Avatar
                      src={userImage}
                      alt="User"
                      sx={{ width: 40, height: 40, marginRight: 2 }}
                    />

                    <Stack direction="column" sx={{ marginRight: 1 }}>
                      <MaterialTypography variant="h6" color="white">
                        {userDetails?.first_name + ' ' + userDetails?.last_name || "Unknown User"}
                      </MaterialTypography>
                      {/* <MaterialTypography variant="caption" color="white">{userDetails?.role_name || "Unknown Role"}</MaterialTypography> */}
                    </Stack>
                  </Box>
                </Tooltip>
                {renderMenu()}
              </MaterialBox>
            </>
          )
        }
      </Toolbar>
    </AppBar>
  );
}

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
